import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllInstagramInfluencersV3.graphql';
import { Query, QueryallInstagramInfluencersV3Args } from '../../__generated__/globalTypes';

export const useAllInstagramInfluencersV3Query = (
  options?: QueryHookOptions<Query, QueryallInstagramInfluencersV3Args>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallInstagramInfluencersV3Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllInstagramInfluencersV3LazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallInstagramInfluencersV3Args>
): QueryResult<Query, QueryallInstagramInfluencersV3Args> & {
  getAllInstagramInfluencersV3: LazyQueryExecFunction<Query, QueryallInstagramInfluencersV3Args>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllInstagramInfluencersV3, result] = useLazyQuery<Query, QueryallInstagramInfluencersV3Args>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllInstagramInfluencersV3, ...result };
};

export const useAllInstagramInfluencersV3PromiseQuery = () => {
  const client = useApolloClient();

  const getAllInstagramInfluencersV3 = useCallback(
    (options?: Omit<QueryOptions<QueryallInstagramInfluencersV3Args, Query>, 'query'>) =>
      client.query<Query, QueryallInstagramInfluencersV3Args>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllInstagramInfluencersV3 };
};
// Suspense Query Hooks
export const useAllInstagramInfluencersV3SuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallInstagramInfluencersV3Args>
) => {
  const result = useSuspenseQuery<Query, QueryallInstagramInfluencersV3Args>(QUERY, {
    ...options
  });

  return result;
};
